import { connect } from "react-redux";
import { hideSidebarAction } from "redux-store/ui-state/sidebar";
import { Sidebar } from "ui/sidebar";

function mapStateToProps(state) {
  const { activeKey, title, data, storePath } = state.pages.sidebar;

  return {
    activeKey,
    title,
    data,
    storePath,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    hideSidebar: () => {
      dispatch(hideSidebarAction);
    },
  };
}

const ConnectedSidebar = connect(mapStateToProps, mapDispatchToProps)(Sidebar);

export { ConnectedSidebar };
